import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const ErrorModal = ({
  open,
  message,
  buttonText = 'Got it',
  onConfirmed,
}) => {
  const handleConfirm = () => {
    if (onConfirmed) {
      onConfirmed();
    }
  };

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      width={360}
      bodyStyle={{
        padding: '20px 24px 16px',
        textAlign: 'center',
      }}
    >
      <div style={{ marginBottom: 12 }}>
        <ExclamationCircleOutlined
          style={{
            fontSize: 36,
            color: '#CBA135',
          }}
        />
      </div>

      <div
        style={{
          marginBottom: 16,
          color: '#666',
          fontSize: 14,
          fontWeight: 500,
          fontFamily: 'Poppins, system-ui, -apple-system, BlinkMacSystemFont',
          whiteSpace: 'pre-wrap',
        }}
      >
        {message}
      </div>

      <Button
        type="primary"
        block
        onClick={handleConfirm}
        style={{
          borderRadius: 8,
          backgroundColor: '#CBA135',
          borderColor: '#CBA135',
          fontFamily: 'Poppins, system-ui, -apple-system, BlinkMacSystemFont',
          fontWeight: 600,
          fontSize: 16,
          color: '#000',
        }}
      >
        {buttonText}
      </Button>
    </Modal>
  );
};

export default ErrorModal;
